import React from 'react';
import SmartClick from './smartClick';
import Icon from '../icon';
import { bem, getDataAttr } from '../_libs/utils';
import { Component, PropTypes } from '../_libs';
import './style';

export default class Tag extends Component {
  render() {
    const displayName = 'tag';
    const { children, type, size, svg,
      enableActive, disabled, closable, round, extra, onClose } = this.props;

    const modifierClassList = {
      [bem(displayName, '', size)]: true,
      [bem(displayName, '', type)]: !!type,
    };

    const stateClassList = {
      'is-disabled': disabled,
      'is-round': round,
      'is-svg': svg || size === 'xs',
    };

    return (
      <SmartClick disabled={disabled} enableActive={enableActive}>
        <span
          className={this.className(bem(displayName), modifierClassList, stateClassList)}
          style={this.style()}
          {...getDataAttr(this.props)}>
          {closable === true ? <span onClick={onClose} role="button">
            <Icon className={bem(displayName, 'close')} icon="close-circle-o" isAuto />
          </span> : ''}
          {extra}
          <span className={bem(displayName, 'text')}>
            {children}
            {svg || size === 'xs' ? <svg className={bem(displayName, 'svg')}>
              <text x="50%" y="50%">
                {children}
              </text>
            </svg> : ''}
          </span>
        </span>
      </SmartClick>
    );
  }
}
Tag.defaultProps = {
  children: 'Tag',
  type: 'default',
  size: 'sm',
  svg: false,
  enableActive: true,
  disabled: false,
  closable: false,
  round: false,
  onClose: () => {},
  extra: null,
};

Tag.propTypes = {
  // @INTRO 标签上的文字
  children: PropTypes.string,
  // @INTRO 标签类型
  type: PropTypes.oneOf([
    'default',
    'primary',
    'info',
    'danger',
    'warning',
    'success',
    'dark',
    'default-reverse',
    'primary-reverse',
    'info-reverse',
    'danger-reverse',
    'warning-reverse',
    'success-reverse',
    'dark-reverse',
  ]),
  // @INTRO 标签尺寸
  size: PropTypes.oneOf([
    'xs',
    'sm',
    'md',
    'lg',
  ]),
  // @INTRO 关闭按钮点击事件
  onClose: PropTypes.func,
  // @INTRO 是否开启点击态
  enableActive: PropTypes.bool,
  // @INTRO 是否不可点击
  disabled: PropTypes.bool,
  // @INTRO 是否使用svg模式
  svg: PropTypes.bool,
  // @INTRO 是否可关闭
  closable: PropTypes.bool,
  // @INTRO 是否是圆角
  round: PropTypes.bool,
  // @INTRO 文字前图标
  extra: PropTypes.node,
  // @INTRO onClick事件 <code>(e)=>{}</code>
  onClick: PropTypes.func, // eslint-disable-line
};
